<template>
  <b-form @submit.prevent="search()">
    <b-modal id="modalSearch" :title="$t('search')" centered no-close-on-backdrop>
      <div class="form-group">
        <label for="console">{{ $t('console') }}</label>
        <multiselect v-validate="'required'" :state="validateState('console')" name="console" id="console" v-model="currentConsole" :options="consoles" deselectLabel="" :placeholder="$t('selectOption')" :searchable="false" selectLabel="" selectedLabel=""></multiselect>
        <span class="error-inputs">{{ errors.first('console') }}</span>
      </div>
      <div class="form-group">
        <label for="type">{{ $t('whatLokingFor') }}</label>
        <select name="type" id="type" class="form-control" v-validate="'required'" :state="validateState('type')" v-model="payload.type">
          <option value="T">{{ $t('tournaments') }}</option>
          <option value="D">{{ $t('divisions') }}</option>
          <option value="TE">{{ $t('teams') }}</option>
          <option value="P">{{ $t('players') }}</option>
        </select>
        <span class="error-inputs">{{ errors.first('type') }}</span>
      </div>
      <div class="form-group">
        <label for="q">{{ $t('textFind') }}</label>
        <b-form-input name="q" id="q" v-model="payload.q" v-validate="'required|min:3'" :state="validateState('q')" data-vv-as="text"></b-form-input>
        <span class="error-inputs">{{ errors.first('q') }}</span>
      </div>
      <template slot="modal-footer">
        <b-button type="button" @click="$root.$emit('bv::hide::modal', 'modalSearch')">{{ $t('close') }}</b-button>
        <b-button type="button" @click="search()" variant="primary">{{ $t('search') }}</b-button>
      </template>
    </b-modal>
    <modal-results-search :items="results" :type="payload.type" />
  </b-form>
</template>
<script>
import { mapGetters } from 'vuex'
import ModalResultsSearch from './ModalSearchResults'

export default {
  components: {
    ModalResultsSearch
  },
  data () {
    return {
      consoles: window.consoles,
      payload: {
        type: 'T'
      },
      results: [],
      currentConsole: null
    }
  },
  created () {
    this.currentConsole = this.$route.params.console ? this.$route.params.console.toUpperCase() : null
  },
  watch: {
    '$route' () {
      this.currentConsole = this.$route.params.console ? this.$route.params.console.toUpperCase() : null
    }
  },
  computed: {
    ...mapGetters(['lang', 'console', 'division', 'loading'])
  },
  methods: {
    search () {
      this.$validator.validate().then(result => {
        if (result) {
          this.payload.console = this.currentConsole.toLowerCase()
          const path = `${this.lang}/console/${this.console}/search`
          this.$axios.get(path, { params: this.payload }).then(response => {
            this.$root.$emit('bv::hide::modal', 'modalSearch')
            this.results = response.data.data
            this.$root.$emit('bv::show::modal', 'modalResultsSearch')
          })
        } else {
          this.showValidationsErrors(this.errors.items)
        }
      })
    }
  }
}
</script>
